var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px"}},[_vm._m(0),_c('div',{staticClass:"col-md-12"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.log,"lineNumbers":false,"search-options":{
        enabled: true,
        placeholder: 'Pesquisar',
      },"pagination-options":{
            enabled: true,
            mode: 'records',
            mode: 'pages',
            perPage: 10,
            position: 'bottom',
            perPageDropdown: [5, 10, 15, 25],
            dropdownAllowAll: false,
            nextLabel: 'Próximo',
            prevLabel: 'Anterior',
            rowsPerPageLabel: 'Linhas por página',
            ofLabel: 'de',
            pageLabel: 'pagina', 
            allLabel: 'All',
      }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'status')?_c('div'):_vm._e()]}}])})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('h4',[_vm._v("Log Cidadão")])])])])}]

export { render, staticRenderFns }